import React from "react";
import Layout from "../../containers/layout/Layout.container";

const NotFoundPage = () => {
  return (
    <Layout>
      <div className="cm-about-page-container">
        <h1>404</h1>
      </div>
    </Layout>
  );
};

export default NotFoundPage;
